import {LayoutSubPage, LayoutWrap} from 'src/styles/common/layout'
import PcHeader from './PcHeader'
import Footer from './Footer'
import SubTop from './SubTop'
import {useLocation} from 'react-router'
import useWindowDimensions from 'src/hooks/useGetWindowSize'
import MoHeader from './MoHeader'
import {useEffect} from 'react'
import {useRecoilState} from "recoil"
import {HeaderUserTab} from "src/store/recoil/common"

const Layout = (props: { children: React.ReactNode }): JSX.Element => {
    const {pathname} = useLocation()
    const {width} = useWindowDimensions()
    const [UserTab, setUserTab] = useRecoilState(HeaderUserTab)

    useEffect(() => {
        window.scroll({top: 0});
    }, [pathname]);
    return (
        <>
            <LayoutWrap onClick={() => UserTab && setUserTab(false)}>
                {width > 1200 ? <PcHeader/> : <MoHeader/>}
                <SubTop/>
                {pathname !== '/'
                    ? <LayoutSubPage>{props.children}</LayoutSubPage>
                    : <>{props.children}</>}
            </LayoutWrap>
            <Footer/>
        </>
    )
}
export default Layout
